
export const formatFullName = (
  firstName?: any,
  middleName?: any,
  lastName?: any
): string => {
  return [firstName, middleName, lastName].filter(Boolean).join(" ");
};

export const formatFullNameWithId = (
  firstName?: any,
  middleName?: any,
  lastName?: any,
  employeeId?: any
): string => {
  const name = formatFullName(firstName, middleName, lastName);
  if (!name) return "";
  return employeeId || employeeId === 0 ? `${name}-${employeeId}` : name;
};
